import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendBug } from '../utils/BugSnag/BugSnagUtilities';
import { PageLoader as CorePageLoader } from '@cfa/react-core';
import { themeSizes } from '../styles/globalStyleVars';

const ChickenSpinner = () => (
  <div style={{ display: 'block' }}>
    <CorePageLoader style={{ margin: `${themeSizes.xxl} auto` }} />
  </div>
);

export const CustomLoginCallback = () => {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        await oktaAuth.handleLoginRedirect();
        navigate('/');
      } catch (error) {
        console.error('Login callback error:', error);

        if (error instanceof Error) {
          sendBug(`Login Error: ${error.message}`, 'error');
          // Storage was cleared, restart auth flow
          await oktaAuth.signInWithRedirect();
        } else {
          sendBug(`Login Error: ${String(error)}`, 'error');
          navigate('/');
        }
      }
    })();
  }, [oktaAuth, navigate]);

  return <ChickenSpinner />;
};
